var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResetQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1377D4;stroke-miterlimit:10;}\n\t.st1{fill:#1377D4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.675,6.908"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.318,21.421l0.002,1.158c1.07-0.2,2.085-0.556,3.019-1.048l-0.572-0.991 C16.003,20.938,15.183,21.24,14.318,21.421z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.233,21.093l-0.585,1.012c1.076,0.396,2.219,0.611,3.387,0.645l-0.002-1.143 C11.07,21.577,10.128,21.402,9.233,21.093z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.658,19.247l0.584,1.01c0.787-0.659,1.48-1.428,2.053-2.283l-0.995-0.566 C19.834,18.091,19.279,18.706,18.658,19.247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.345,15.376l1.006,0.572c0.35-0.884,0.592-1.821,0.696-2.801l-1.155,0.003 C21.799,13.924,21.611,14.668,21.345,15.376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.837,17.909l-0.93,0.663c0.822,1.152,1.529,1.774,2.693,2.512l0.57-0.987 C6.146,19.44,5.563,18.926,4.837,17.909z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.894,10.864l1.154-0.003c-0.572-5.403-5.154-9.628-10.706-9.628c-3.417,0-6.623,1.642-8.653,4.391 L0.767,3.938l0.015,8.13l7.044-4.058L4.687,6.2c1.818-2.395,4.643-3.824,7.655-3.824C17.264,2.376,21.329,6.092,21.894,10.864z  M1.921,10.094L1.913,5.918L5.539,8.01L1.921,10.094z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResetQuiz);
export default __webpack_public_path__ + "static/media/icon-reset-quiz.5fd5b78eb32ee54272f1189a424b9c24.svg";
export { ForwardRef as ReactComponent };